﻿(function (document) {

    function ReinitializeTogglers() {
        var togglerElems = document.querySelectorAll('[data-collapse]:not([data-init="true"])');
        for (var i = 0; i < togglerElems.length; i++) {

            togglerElems[i].addEventListener('click', function (e) {
                var targetElement = this.nextElementSibling;
                if (targetElement.classList.contains('collapsed')) {
                    this.classList.add('open');
                    targetElement.classList.remove('collapsed');
                } else {
                    this.classList.remove('open');
                    targetElement.classList.add('collapsed');
                }
            });

            togglerElems[i].dataset.init = true;
        }

    };

    document.addEventListener('DOMContentLoaded', function (e) {
        ReinitializeTogglers();
    });


})(document);
